import { ReactComponent as DownloadCloudSvg } from '../../assets/icons/download-cloud.svg';

export const DownloadCloudIcon: SvgIcon = (props) => {
    return <DownloadCloudSvg {...props} />;
};
